import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import calenderReducer from './slices/calendar';
import uiReducer from './slices/ui';
import userReducer from './slices/user';
import authReducer from './slices/auth';
import settingsReducer from './slices/settings';
import jenjangReducer from './slices/jenjang';
import kelasReducer from './slices/kelas';
import translationReducer from './slices/translation';
import paralelReducer from './slices/paralel';
import tahunAjaranReducer from './slices/tahun_ajaran';
import SemesterReducer from './slices/semester';
import modalsReducer from './slices/modal';
import PerusahaanReducer from './slices/perusahaan';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [
    'settings',
    'jenjang',
    'kelas',
    'parallel',
    'tahun_ajaran',
    'ui',
    'semester',
    'perusahaan',
  ],
};

const authPersistConfig = {
  key: 'auth',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['isAuthenticated'],
};

const rootReducer = combineReducers({
  user: userReducer,
  ui: uiReducer,
  settings: settingsReducer,
  auth: persistReducer(authPersistConfig, authReducer),
  calendar: calenderReducer,
  jenjang: jenjangReducer,
  kelas: kelasReducer,
  translate: translationReducer,
  modals: modalsReducer,
  parallel: paralelReducer,
  tahun_ajaran: tahunAjaranReducer,
  semester: SemesterReducer,
  perusahaan:PerusahaanReducer,
});

export { rootPersistConfig, rootReducer };
